import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import { Promise } from "rsvp"

export default class StripeInvoiceRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return new Promise((resolve, _reject) => {
      return get(this, "store")
        .find("stripe-invoice", params.id)
        .then((stripeInvoice) => {
          return get(this, "store")
            .find("user-summary", stripeInvoice.relationships.user.data.id)
            .then((user) => {
              resolve({ user, stripeInvoice, todayDate: new Date() })
            })
        })
    })
  }
}
